export default __webpack_public_path__ + "static/media/oval_a.b88aacf2.svg";